/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  textField: {
    color: theme.palette.primary.contrastText,
  },
  cssLabel: {
    'color': theme.palette.primary.light,
    '&$cssFocused': {
      color: theme.palette.primary.contrastText,
    },
  },
  cssFocused: {},
  cssOutlinedInput: {
    'color': 'white',
    '&$cssFocused $notchedOutline': {
      borderColor: theme.palette.primary.contrastText,
    },
    '& $notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
  },
  notchedOutline: {},
}));

const OutlinedTextField = ({ onChange, label, value, onEnter, ...props }) => {
  const classes = useStyles();

  return (
    <TextField
      id={`outlined-${label}`}
      label={label}
      className={classes.textField}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      margin='normal'
      variant='outlined'
      fullWidth
      InputLabelProps={{
        classes: {
          root: classes.cssLabel,
          focused: classes.cssFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.cssOutlinedInput,
          focused: classes.cssFocused,
          notchedOutline: classes.notchedOutline,
        },
        onKeyPress: ({ key }) => {
          if (key === 'Enter' && onEnter) onEnter();
        },
      }}
      {...props}
    />
  );
};

export default OutlinedTextField;
